import {
  FETCH_SESSION_USER,
  FETCH_COOKIE_USER,
  FETCH_DIGITAL_ASSAYS_USER,
  FETCHING_SESSION,
  SESSION_ERROR
} from "../actions/user";

const initialState = {
  authenticating: true,
  evoSession: false,
  evoCookie: false,
  digitalAssaysUser: false
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_SESSION:
      return Object.assign({}, state, { authenticating: true });
    case FETCH_SESSION_USER:
      return Object.assign({}, state, {
        evoSession: action.payload
      });
    case FETCH_COOKIE_USER:
      return Object.assign({}, state, {
        evoCookie: action.payload
      });
    case FETCH_DIGITAL_ASSAYS_USER:
      return Object.assign({}, state, {
        digitalAssaysUser: action.payload,
        authenticating: false
      });
    case "LOGOUT":
      return Object.assign({}, state, {
        evoSession: false,
        evoCookie: false,
        digitalAssaysUser: false,
        authenticating: false
      });
    case SESSION_ERROR:
      return Object.assign({}, state, {
        errorInfo: action.err,
        authenticating: false
      });
    default:
      return state;
  }
};

export default user;
